<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'周目标明细'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
          <div class="h-piece">
            <div class="h-formBox">
              <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="姓名">
                    <el-input v-model="q.userName" placeholder="请输入创客名称"></el-input>
                  </el-form-item>

                  <el-form-item label="区域" prop="searchQuyu">
                    <brselect clearable category="show_area" :v="q.quyuCode"
                              v-model="q.quyuCode"></brselect>
                  </el-form-item>

                  <el-form-item  label="月" class="h-elformWrap-2" prop="username">
                    <el-select filterable v-model="q.qMonth" clearable  placeholder="请选择">
                      <el-option
                          v-for="(item,index) in monthList"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item  label="周" class="h-elformWrap-2" prop="username">
                    <el-select filterable v-model="q.week" clearable  placeholder="请选择"
                    >
                      <el-option
                          v-for="(item,index) in qweekList"
                          :key="item.week"
                          :label="item.weekStr"
                          :value="item.week">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </div>
                <el-collapse-transition>
                    <div class="h-thirdColumn w-newColumn">


                    </div>
                </el-collapse-transition>

              </el-form>
              <div class="l-screenBox">
                <div class="l-retrieval">
                  <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                </div>
              </div>
            </div>
          </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="500"
                    :span-method="objectSpanMethod"
                    style="width: 100%" >
                  <el-table-column prop="userName" label="姓名" width="70" ></el-table-column>
                  <el-table-column prop="quyuName"  label="区域" width="70" ></el-table-column>
                  <el-table-column prop="titleName"  label="职位" width="70" ></el-table-column>
                  <el-table-column prop="channelName"  label="渠道" width="70" ></el-table-column>
                  <el-table-column prop="week" label="周" width="50" ></el-table-column>
                  <el-table-column prop="year" label="年" width="60" ></el-table-column>
                  <el-table-column prop="monthIncome" label="月收入" width="80" ></el-table-column>
                  <el-table-column prop="monthSamePeriod" label="月同期" width="80"  ></el-table-column>
                  <el-table-column prop="incomeCount" label="累计签收" width="80"></el-table-column>
                  <el-table-column prop="placeAnOrder" label="累计下单" width="80" ></el-table-column>
                  <el-table-column prop="weekPrice" label="周预计再下单" width="80" ></el-table-column>
                  <el-table-column prop="monthPrice" label="月预计再下单" width="80" ></el-table-column>
                  <el-table-column prop="finishRate" label="完成率" width="80" ></el-table-column>
                  <el-table-column prop="increase" label="幅增" width="80" ></el-table-column>
                  <el-table-column prop="projectType" label="项目分类" width="80" ></el-table-column>
                  <el-table-column prop="customerName" label="项目名称" width="80" ></el-table-column>
                  <el-table-column prop="targetContent" label="目标内容" width="80" ></el-table-column>
                  <el-table-column prop="targetFinishRate" label="目标达成率" width="80" ></el-table-column>
                  <el-table-column prop="diffAnalysis" label="差异分析" width="80" ></el-table-column>
                  <el-table-column prop="summaryContent" label="总结" width="80" ></el-table-column>
                  <el-table-column prop="comment" label="预实差分析" width="80" ></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL" style="margin-left: 23px">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>

    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
import moment from "moment";
export default {
    data() {
        return {
            q:{
                userName:'',
                deptName:'',
                week:'',
                qMonth:'',
                year:new Date().getFullYear(),
                ndate:'',
                pageNo: 1,
                pageSize: 10,
                total:0,
                projectType:'',
            },
            size:'',
            tableData: [
              {
                userName:null,
                quyuName:null,
                titleName:null,
                week:null,
                monthIncome:null,
                monthSamePeriod:null,
                incomeCount:null,
                placeAnOrder:null,
                weekPrice:null,
                monthPrice:null,
                finishRate:null,
                increase:null,
                projectType:null,
                customerName:null,
                customerCode:null,
                targetContent:null,
                targetFinishRate:null,
                diffAnalysis:null,
                summaryContent:null,
                sysScore:null,
                comment:null,
              }
            ],
            times:[],
            qweekList :[],
            monthList:['01','02','03','04','05','06','07','08','09','10','11','12'],
            newDialog:false,
            writeNissin:false,
            editDialog:false,
            // 展开折叠筛选
            isScreen:false,
            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
            weekList:[],
            disEdit:false,
            workList:[],
            deptList: [],
            authTypeList: [],
            userList: [0],
            weekPlanList:[],
            groupList: [],
            groupArr:[],
            titleDig:"",
            optionList:[],
            projectList:[],
            qyearList:[],
            position: 0,

            rowSpanArr: [],
        }
    },
    methods: {
      //明细导出
      exportExcel() {
        this.q.projectType = this.q.qMonth;
        ss.MuBiao.downloadBatchExcelSummary(this.q).then(res => { // 处理返回的文件流
          const link = document.createElement('a')
          let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', `周目标明细.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }).catch(function (error) {
          console.log("导出错误",error.toString())
        });
      },
        showFormList(value) {
            ss.MuBiao.getUser(value).then(res => {
                this.optionList = res.msg
            })
        },
        //项目类型
        getProject(){
            ss.MuBiao.getProject().then(res => {
                this.projectList = res.msg
            })
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },
        getKnowWeek() {
          var week1 = this.getWeekNum();
          this.qweekList.forEach(element => {
            if(week1 == element.week){
              this.q.week = element.week
            }
          });
        },
        getqWeeks(y,z){
          ss.MuBiao.getWeekList({year:y,stype:z}).then(rd => {
            this.qweekList = rd;
            this.getKnowWeek();
          })
        },
        groupListMe() {
            var data  = this.add.customerName
             ss.MuBiao.getUser(data).then(res => {
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },

      //获取今年是第几周
      getWeekNum() {
        //获得当前日期是第几周的方法
        var year = new Date().getFullYear();
        var week = moment(new Date()).format("E");//获得今天是星期几
        var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
        //今天到1月1号的时间戳之差
        var millisDiff =
            new Date(moment().format("yyyy-MM-DD")).getTime() -
            new Date(year + "-01-01").getTime();
        var days =
            (millisDiff -
                week * (24 * 60 * 60 * 1000) -
                (7 - startweek) * (24 * 60 * 60 * 1000)) /
            86400000;
        return days / 7+1;
        //这里加的2代表的是本周和今年1月1号所在的那一周
      },
      query(){
      this.selectPageAll()
      },
      selectPageAll(){
        console.log(this.q.week);
        ss.MuBiao.getSummaryWeek(this.q).then(res => {
          this.q.total = res.msg.total;
          this.tableData = res.msg.records
          for(var i=0;i<this.tableData.length;i++){
            if(this.tableData[i].finishRate != null && this.tableData[i].finishRate != ''){
              let str1 = Number(this.tableData[i].finishRate * 100).toFixed(0);
              this.tableData[i].finishRate = str1 + "%";
            }else {
              this.tableData[i].finishRate = 0 + "%";
            }
            if(this.tableData[i].targetFinishRate != null && this.tableData[i].targetFinishRate != '' && this.tableData[i].targetFinishRate != '0.0'){
              let str2 = Number(this.tableData[i].targetFinishRate * 100).toFixed(0);
              this.tableData[i].targetFinishRate = str2 + "%";
            }else {
              this.tableData[i].targetFinishRate = 0 + "%";
            }
          }
          this.getRowSpans();
        })
      },
        querySearchGroup(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup(val) {
             this.add.customerName= val.value
        },
        groupListMe1() {
            var data  = this.edit.customerName
             ss.MuBiao.getUser(data).then(res => {
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },
        querySearchGroup1(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup1(val) {
             this.edit.customerName= val.value
        },

        changeHandler(value) {
            //console.log('改变之后的值是:' + value)
            let data =  this.authTypeList
            let item = this.add.userList
　　　　　　 // 使用find方法根据id查询对应对象
            let a =  data.find((ele)=>{
                return ele.id == item
            });
            var arr3 =a
            if(!arr3.id){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    this.add.clearType = 2
                    this.disEdit = true
                }else{
                    this.add.targetContent = arr3.targetContent,
                    this.add.customerName= arr3.customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3.projectName
                    this.disEdit = false
                    this.add.id = this.add.userList
                }
        },
      handleFilter() {
        if (this.q.qMonth){
          if (this.q.week){
            this.$message({
              type: "error",
              message: '当选择月份时不能选择周！'
            });
            return false;
          }
        }
        this.query();
      },
        groupChange() {
            if (this.add.userList.length > 1) {
                this.add.userList.shift();
            }
            var arr3 =[]
                this.add.userList.forEach((item) => {
					this.authTypeList.forEach((element) => {
						  if (item == element.id) {
							arr3.push(element)
						  }
					})
                })
                if(arr3.length == 0){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    //
                    this.add.clearType = 2
                    this.disEdit = false
                }else{
                    this.add.targetContent = arr3[0].targetContent,
                    this.add.customerName= arr3[0].customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3[0].projectName
                    this.disEdit = true
                    this.add.id = this.add.userList[0]
                }
        },

        //获得周计划列表
        getWeekPlan(year,week){
            var year = this.add.year
            var week = parseInt(this.add.week)
            var data = {
                year:year,
                week:week
            }
            ss.MuBiao.getListPlan(data).then(res => {
                if(res.f == true ){
                    this.authTypeList = res.msg
                }else{
                    this.$message.error(res.msg);
                }
            })
        },

        getNowTime() {
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth(); //得到月份
            var date = now.getDate(); //得到日期
            month = month + 1;
            month = month.toString().padStart(2, "0");
            date = date - 1;
            date = date.toString().padStart(2, "0");
            var defaultDate = `${year}-${month}-${date}`;
            this.$set(this.q, "planCreateTime", defaultDate);
        },

        getWeeks(y){
            ss.MuBiao.getWeekList({year:y}).then(rd => {
                this.weekList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                this.addlianqunList = rd;
            })
        },

        selectWeek(){
            this.getWeekPlan()
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        rest(){
            var week=this.q.week;
            var year=this.q.year;
            this.q= {
                userName:'',
                week: week,
                year:year
            }
        },
        exit(){
            this.closeDialog()
        },
      mounted() {

      },
        closeDialog(){
            this.newDialog = false
            this.editDialog = false
            this.writeNissin = false
            this.xxx = '';//清空数据

            this.add.targetContent='',
            this.add.customerName='',
            this.add.clearType='2',
            this.add.projectName=''

            this.edit.targetContent='',
            this.edit.customerName='',
            this.edit.projectName=''

        },
      getRowSpans() {
        this.rowSpanArr = [];
        this.tableData.forEach((item, index) => {
          if (index == 0) {
            this.rowSpanArr.push(1);
            this.position = 0;
          } else {
            if (this.tableData[index].userName== this.tableData[index - 1].userName && this.tableData[index].week== this.tableData[index - 1].week
                && this.tableData[index].quyuName== this.tableData[index - 1].quyuName) {
              this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
              this.rowSpanArr.push(0);
              this.tableData[index].userName= this.tableData[index - 1].userName;
            } else {
              this.rowSpanArr.push(1);
              this.position = index;
            }
          }
        });

      },

      objectSpanMethod({ row,column, rowIndex,columnIndex }) {
        // 只合并区域位置
        if (columnIndex === 0) {
          const _row = this.rowSpanArr[rowIndex];
          return {
            rowspan: _row, //行
            colspan: 1 //列
          };
        }
        if(columnIndex === 1){
          const _row = this.rowSpanArr[rowIndex];
          const _col = _row>0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        if(columnIndex === 2 || columnIndex === 4 ||columnIndex === 3 ||columnIndex === 8 || columnIndex === 5 || columnIndex === 6 || columnIndex === 7 ||
            columnIndex === 9 || columnIndex === 10 || columnIndex === 11 ||columnIndex === 12  || columnIndex === 16 || columnIndex === 17 || columnIndex === 19){
          const _row = this.rowSpanArr[rowIndex];
          const _col = _row>0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          }
        }
      },
    },
    watch:{
        'add.customerName': {
            deep: true,
            handler: function (newVal,oldVal){
            this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
            var len = this.groupList.length;//groupList
            var arr = [];
            for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                arr.push({
                    value:this.groupList[i].name,
                    id:this.groupList[i].id
                })
                }
            }
            this.groupArr = arr
            }
        },
    },
    created(){
        this.getWeeks(new Date().getFullYear());
        this.getqWeeks(new Date().getFullYear(),1);
        for(var i =2021;i<new Date() .getFullYear()+2;i++){
          this.qyearList.push(i);
        }
        this.handleFilter();
        this.getProject()
        this.getDept();
        this.getNowTime();
        if(this.getWeekNum() == 0){
          this.q.week = '52'
          this.q.year =new Date().getFullYear()-1
        }else {
          this.q.week = this.getWeekNum();
          this.q.year =new Date().getFullYear();
        }
        this.selectPageAll();
    },

}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:80px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /deep/ .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }

    .projectCon p{
      justify-content: space-between;
      align-items:center;
      font-size: 14px;
      border-bottom:#1b78e6 1px dashed;
      padding: 5px 0;
      margin: 0 auto 10px auto;
      color: #1b78e6;
    }
</style>